import React from 'react'
import { formatMessageNew } from '@/utils/common'

const UnAuthorized = () => (
  <div
    className="content-container"
    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
  >
    <div style={{ fontSize: '22px', textAlign: 'center' }}>
      <p style={{ marginBottom: '10px', fontSize: '25px', color: 'red' }}>
        {formatMessageNew('languageObj.commonLocale.errorAuth')}
      </p>
      <p style={{ marginBottom: '10px' }}>{formatMessageNew('languageObj.commonLocale.errorTitle1')}</p>
      <p>{formatMessageNew('languageObj.commonLocale.errorTitle2')}</p>
    </div>
  </div>
)

export default UnAuthorized
